<script setup>
const props = defineProps({
  center: {
    type: Object,
    required: true
  }
})
const { data: obsData } = await useFetch('/api/wxdata/fcstobs', { query: { lat: props.center.lat, lon: props.center.lon } })
</script>

<template>
  <section class="observedValue">
    <CommonSectionTitle
      title="実況天気・観測値"
      :sun="obsData.sun"
    />
    <div class="box">
      <div class="icon">
        <figure>
          <img
            :src="`https://gvs.weathernews.jp/onebox/img/wxicon/${obsData.obs.weather}.webp`"
            loading="lazy"
            alt=""
          >
        </figure>
        <div class="weatherText">
          {{ obsData.obs.weatherJp }}
        </div>
      </div>
      <ul class="list">
        <li
          v-for="(item, index) in obsData.data"
          :key="index"
          class="block"
        >
          <p class="title">
            {{ item.title }}
          </p>
          <div class="content">
            <div class="inner">
              <figure
                v-if="item.windDir"
                class="wind"
              >
                <svg
                  v-if="item.value!==0 && item.value!==null"
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="15"
                  viewBox="0 0 11 15"
                  :data-rank="item.windRank"
                  :style="`transform: rotate(calc(1deg * ${item.windDir*22.5}))`"
                >
                  <path
                    d="M9.91706 1.33286L5.48529 13.7418L1.05353 1.33286L5.31805 5.17093L5.48529 5.32145L5.65253 5.17093L9.91706 1.33286Z"
                    stroke="#333333"
                    stroke-width="0.5"
                  />
                </svg>
              </figure>
              <p class="value">
                {{ item.value === null ? '-' : item.value }}
              </p>
            </div>
            <p class="unit">
              {{ item.unit }}
            </p>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.observedValue {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .box {
    display: flex;
    align-items: stretch;
    gap: 10px;
    padding: 4px;
    border-radius: 6px;
    background-color: #EEF1F8;
  }
  .icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    figure {
      width: 60px;
      aspect-ratio: 152 / 112;
      img {
        width: 100%;
      }
    }
    .weatherText {
      color: #616161;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 17px;
    }
  }
  .list {
    flex: 1;
    display: flex;
    align-items: stretch;
    gap: 4px;
    .block {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 6px;
      flex: 1;
      padding: 6px;
      border-radius: 6px;
      background-color: #FFF;
    }
    .title {
      color: #606060;
      font-size: 14px;
      line-height: 1em;
    }
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .inner {
      display: flex;
      align-items: center;
    }
    .wind {
      display: flex;
      align-items: center;
      width: 14px;
      height: 14px;
      svg {
        &[data-rank='0'] {
        fill: #ffffff;
        }
        &[data-rank='1'] {
          fill: #03aeef;
        }
        &[data-rank='2'] {
          fill: #05ad50;
        }
        &[data-rank='3'] {
          fill: #febf00;
        }
        &[data-rank='4'] {
          fill: #e86200;
        }
        &[data-rank='5'] {
          fill: #fe0000;
        }
      }
    }
    .value {
      color: #606060;
      font-size: 14px;
      font-weight: 600;
      line-height: 1em;
    }
    .unit {
      color: #606060;
      font-size: 10px;
      font-weight: 300;
      line-height: 1em;
    }
  }
}
@media  (min-width: 830px) {
  .observedValue {
    .box {
      padding: 8px;
      border-radius: 8px;
    }
    .list {
      .content {
        flex-direction: row;
        align-items: flex-end;
      }
      .title {
        font-size: 16px;
      }
      .value {
        font-size: 15px;
      }
      .unit {
        font-size: 12px;
      }
    }
  }
}
</style>
